import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliButton, Text } from '@lili/lili-frontend-common';
import BalanceUpLottie from '../../../assets/lotties/balance_up.json';
import Lottie from '../../../generic-components/Lottie';
import { featureAccess, LimitedFeatureType } from '../../../services/appAccess.service';
import { FeatureAccess } from '../../../pages/AccountSettings/components/rolesAndPermissions/PermissionsList';

interface IProps {
  onSubmit: () => void;
  overDraftLimit: string | number;
  isLoading: boolean;
}

const BalanceUpHappyEnroll = ({ onSubmit, overDraftLimit, isLoading }: IProps) => {
  const { t } = useTranslation('balanceUpTranslation');

  const shouldDisableActivation = featureAccess(null, LimitedFeatureType.BalanceToggle) !== FeatureAccess.READ_WRITE;

  return (
    <div className='flex flex-col h-full justify-center items-center'>
      <Lottie className='w-[195px] h-[120px] mb-[24px]' isAutoplay isLoop={false} lottieAsset={BalanceUpLottie} />
      <Heading.H5 fontWeight={FontWeight.SEMIBOLD} className='mb-[8px]'>
        {t('ELIGIBLE_ACTIVATE.TITLE', { sum: overDraftLimit })}
      </Heading.H5>
      <Text.H9 className='text-text-main-secondary text-center w-[472px] mb-[32px]'>
        {t('ELIGIBLE_ACTIVATE.SUBTITLE', { sum: overDraftLimit })}
      </Text.H9>
      <LiliButton
        disabled={shouldDisableActivation}
        isLoading={isLoading}
        onClick={onSubmit}
        id='enrollCta'
        className='w-[215px]'
        title={t('ELIGIBLE_ACTIVATE.CTA')}
      />
    </div>
  );
};

export default BalanceUpHappyEnroll;
